import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  blogs = [
    {
      'slug':'tips-and-tricks-to-use-solar-power-equipment-with-ease',
      'title':'Tips and tricks to use solar power equipment with ease',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'blog-title-4',
      'title':'Blog Title 4',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'tips-and-tricks-to-use-solar-power-equipment-with-ease',
      'title':'Tips and tricks to use solar power equipment with ease',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    },
    {
      'slug':'tips-and-tricks-to-use-solar-power-equipment-with-ease',
      'title':'Tips and tricks to use solar power equipment with ease',
      'excerpt':'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....',
      'content':"<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.</p>",
      'postImage':'./assets/images/blog-banner.jpg',
      'likeCount':145,
      'commentCount':78,
      'date':'May 02, 2019',
      'author':'Rajesh Sharma',
      'comments':[
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Sunil Sharma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        },
        {
          'profileImage':'./assets/images/user.jpg',
          'commentBy':'Shweta Verma',
          'date':'June 27, 2017',
          'comment':'It is dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown',
        }
      ]
    }
  ];
}
